import { Injectable } from '@angular/core';
import { HttpService } from './shared/services/http-service.service';
import { environment } from '../environments/environment';
import { lastValueFrom, map, Observable } from 'rxjs';
import { NgxRolesService } from 'ngx-permissions';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class AppService {
    userData:any={};
    constructor(private httpService: HttpService, private ngxRolesService:NgxRolesService,private router: Router) { }
    getPartNos(sitecode: any): Observable<any> {
        return this.httpService.get(environment.baseUrl+"/PartsCategorization/GetPartNumbers?terminal="+sitecode);
    }

    getIPFilterOptions(): Observable<any> {
      return this.httpService.get(environment.baseUrl+"/InventoryPlanning/GetFilterOptions");
    }

    getAuthriseUserRole() {
        return this.httpService.get(`${environment.baseUrl}/Login/AuthorizeUserRole`);
     }

     getUserRoleData(){
        return this.userData;
     }
     setUserRoleData(userRoleData:any){
        this.userData=userRoleData;
     }

      processRolePermission(permissionObj:any){
        let permissionArr:any=[];
        let userRole:any=permissionObj.userRole;
        permissionArr=this.simplyfyPermission('Admin',permissionObj.admin,permissionArr);
        permissionArr=this.simplyfyPermission('GlobalOverview',permissionObj.globalOverview,permissionArr);
        permissionArr=this.simplyfyPermission('InventoryPlanning',permissionObj.inventoryPlanning,permissionArr);
        permissionArr=this.simplyfyPermission('PartsCategorization',permissionObj.partsCategorization,permissionArr);
        permissionArr=this.simplyfyPermission('PartsPlanning',permissionObj.partsPlanning,permissionArr);
        permissionArr=this.simplyfyPermission('PlanningOverview',permissionObj.planningOverview,permissionArr);
        permissionArr=this.simplyfyPermission('ValueCategorization',permissionObj.valueCategorization,permissionArr);
        

        permissionArr=this.simplyfyPermission('isPartsCategorization',permissionObj.isPartsCategorization,permissionArr);
        permissionArr=this.simplyfyPermission('isPartsPlanning',permissionObj.isPartsPlanning,permissionArr);

        if(permissionObj?.actionPartsPlanning!=""){
          let actionPartPermArr=permissionObj.actionPartsPlanning.split("/");
          
          for(let i=0;i<actionPartPermArr.length;i++){
            permissionArr=this.simplyfyPermission('PartsPlanning',actionPartPermArr[i],permissionArr);
          }
        }
        
        this.ngxRolesService.addRoleWithPermissions(userRole, permissionArr)
        //this.permissionsService.loadPermissions([userRole]);
        
    
     }

     simplyfyPermission(permissionType:string,permissionVal:any,permissionArr:any){
        switch(permissionVal) {
          case "W":
            permissionArr.push(`canWrite${permissionType}`);
            permissionArr.push(`canRead${permissionType}`);
            break;
          case "R":
            permissionArr.push(`canRead${permissionType}`);
            break;
          case "Accept":
            permissionArr.push(`canAccept${permissionType}`);
            break;
          case "Reject":
            permissionArr.push(`canReject${permissionType}`);
            break;

          case "AcceptL1":
            permissionArr.push(`canAcceptL1${permissionType}`);
            break;
          case "RejectL1":
            permissionArr.push(`canRejectL1${permissionType}`);
            break;
          
          case "AcceptL2":
            permissionArr.push(`canAcceptL2${permissionType}`);
            break;
          case "RejectL2":
            permissionArr.push(`canRejectL2${permissionType}`);
            break;

          case "Resubmit":
            permissionArr.push(`canResubmit${permissionType}`);
            break;
          case "CaseClose":
            permissionArr.push(`canCaseClose${permissionType}`);
            break;
          case "ProposeNew":
            permissionArr.push(`canProposeNew${permissionType}`);
            break;

          case true :
            permissionArr.push(`canTrue${permissionType}`);
            break;

          case false :
            permissionArr.push(`canFalse${permissionType}`);
            break;
          default:
            // code block
        }


        console.log(permissionArr);
        
        return permissionArr;
       }
   
}
